
module.config(function($stateProvider) {

    $stateProvider.state('program.info.description', {
        url: '/description',
        templateUrl: 'programs/info/description',
        permission: 'viewDescription',
        resolve: {
            description: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'description');
            },
            // addresses: function(program, permissions, ModelService) {
            //     return permissions.viewAddresses &&
            //         ModelService.getModelRelation(program, 'addresses');
            // },
            // websites: function(program, permissions, ModelService) {
            //     return permissions.viewWebsites &&
            //         ModelService.getModelRelation(program, 'websites');
            // },
            // details: function(program, ModelService) {
            //     return ModelService.get('program', program.id);
            // },
        },
        controller: function($scope, description) {
            $scope.description = description;
            // $scope.addresses = addresses;
            // $scope.websites = websites;
            // $scope.details = details;
        },
    })

});
